// extracted by mini-css-extract-plugin
module.exports = {"emi":"EmiOffer_emi__rmOFk","heading":"EmiOffer_heading__cCfXK","bottom_btn":"EmiOffer_bottom_btn__qvfyA"};